// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';
import { useAuthStatus } from '../hooks/useAuthStatus';
import { Alert, Box, Button } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

const ProtectedRoute = () => {
  const { user, isLoading } = useAuth();
  const { authStatus, loading: authChecking, error: authError, checkAuthStatus } = useAuthStatus();

  const handleRetryBackendConnection = () => {
    checkAuthStatus(true); // Force refresh
  };

  if (isLoading || (user && authChecking)) {
    return <LoadingSpinner />;
  }

  // If not authenticated, redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If backend connection failed (not just unchecked), show warning but continue
  if (authStatus === false && authError) {
    return (
      <>
        <Box sx={{ mb: 2 }}>
          <Alert
            severity="warning"
            action={
              <Button
                color="inherit"
                size="small"
                startIcon={<RefreshIcon />}
                onClick={handleRetryBackendConnection}
              >
                Retry Connection
              </Button>
            }
          >
            Warning: Connection to backend services is not working. Some features may be limited.
            Error: {authError}
          </Alert>
        </Box>
        <Outlet />
      </>
    );
  }

  // If authenticated, render the route (auth check may still be pending)
  return <Outlet />;
};

export default ProtectedRoute;